<script>
  import CopyToClipboard from "svelte-copy-to-clipboard";
  import { RssFill } from "svelte-bootstrap-icons/lib/";
  import { onDestroy } from "svelte";

  let pulse = false;
  let interval;
  function handleSuccessfullyCopied() {
    pulse = true;
    if (interval) {
      clearInterval(interval);
    }
    interval = setInterval(function () {
      return (pulse = false);
    }, 2000);
  }

  function handleFailedCopy() {
    console.log("failed to copy :(");
  }

  export let identifier;
  $: rssFeed = `https://openpod.abbiamoundominio.org/podcast/${identifier}`;

  onDestroy(() => {
    if (interval) {
      clearInterval(interval);
    }
  });
</script>

<style>
  .confirm {
    opacity: 0;
  }

  @keyframes pulse {
    0% {
      opacity: 0;
    }
    25% {
      opacity: 1;
    }
    75% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  .pulse {
    opacity: 0;
    animation: pulse 2s;
  }
</style>

<div class="d-flex align-items-center mb-auto flex-column w-100">
  <CopyToClipboard
    text={rssFeed}
    on:copy={handleSuccessfullyCopied}
    on:fail={handleFailedCopy}
    let:copy>
    <button
      on:click={copy}
      class="btn btn-outline-primary d-flex align-items-center p-md-auto">
      <span class="mr-2">Copia RSS Feed</span>
      <RssFill />
    </button>
  </CopyToClipboard>
  <span class:pulse class="confirm pt-1">Copiato!</span>
</div>
